<div>
  <section >
    <div class="wrapper">
    <div class="styled-input">
    <label class="diagnostic-label">Toxicity</label>
    <button type="button" class="add-boutton" style="left: 435px;" name="Add">Add</button>

    </div>
</div>
</section>

